import { isFutureDate } from "./is-future-date.mjs";
import { TimeUnit } from "./constants/index.mjs";
export function isLessThanOneMinuteAgo(date) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  return !isFutureDate(date, now) && now.getTime() - date.getTime() < TimeUnit.Minute;
}